/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useHistory, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumbs,
  Grid, InputAdornment,
  Link,
  Paper, Tooltip,
  Typography
} from '@mui/material';
import { ROUTES, ROUTES_FOR_KAZAKH_ASSETS } from '../../../../constants/routes';
import { CustomButton } from '../../../../components/CustomButton';
import { useFormik } from 'formik';
import { validationFiles } from '../../../bonuses/pages/AddEvent/utils';
import { ENTITY, PROMOCODES_GENERATOR } from '../../constants/index';
import { useDispatch, useSelector } from 'react-redux';
import { CustomSelect } from '../../../../components/CustomSelect';
import { CustomModal } from '../../../../components/CustomModal';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as PercentIcon } from '../../../../assets/images/percent.svg';
import { CustomDateTimePicker } from '../../../../components/CustomDateTimePicker';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';
import { UploadFiles } from '../../../../components/UploadFiles';
import { CustomRadioGroup } from '../../../../components/CustomRadioGroup';
import {
  getPromotionById,
  getPartnersList,
  getCities,
  getCMS,
  updatePromotion,
  createPromotion,
  uploadCustomerFiles,
  deleteCustomerFiles,
  uploadPromoFiles,
  deletePromoFiles,
  getCustomerFiles,
  getPromoFiles, copyPromotion
} from '../../../../store/partners/actions';
import { CustomMultiSelect } from '../../../../components/CustomMultiSelect';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ADD_EVENT_MODE } from '../../../bonuses/constants/addEventMode';
import { CustomCounter } from '../../../../components/CustomCounter';
import AddIcon from '@mui/icons-material/Add';
import { CircularProgressCenter } from '../../../../components/CircularProgressCenter';
import { createPromotionFields, validationScheme } from './utils';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { PERMISSIONS } from '../../../../constants/variables';
import { getAssetUrl } from '../../../../utils/getAssetUrl';
import { PromotionDescriptionContent } from '../../components/PromotionDescriptionContent';

const mainStyleInput = {
  variant: 'outlined',
  size: 'small'
};

export const AddPromotion = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();

  const addEventMode = id === ':id' ?
    ADD_EVENT_MODE.Create :
    location.pathname.match(ROUTES.PARTNERS_COPY_PROMOTION.replace(':id', id)) ?
      ADD_EVENT_MODE.Copy :
      ADD_EVENT_MODE.Edit;
  const isEdit = addEventMode === ADD_EVENT_MODE.Edit;
  const isCopy = addEventMode === ADD_EVENT_MODE.Copy;

  const { promotionCard, fetchingCard, partnersList, cities: branches, cms, error, customerFiles, promoFiles } = useSelector(state => state.partners);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);
  const isAllowedToListPartners = visibleBySectionPermission(permissions, PERMISSIONS.PARTNERS.listPartners.value);
  const cities = branches
    ?.map((city, index, array) => array.findIndex(item => city.name === item.name) === index && city)
    .filter(city => city)
    .map(city => ({ label: city?.name, value: city?.id }));
  cities?.unshift({ label: 'Все', value: 'all' });

  const partnerDetailPath = ROUTES.PARTNERS_DETAIL_PARTNER.replace(':id', '');
  const isCreatingFromPartnerCard = !!location.state?.from?.match(partnerDetailPath);
  let initialPartner = null;

  if (isCreatingFromPartnerCard) {
    const partnerCardId = location.state.from.replace(partnerDetailPath, '');

    if (partnersList?.length && partnerCardId) {
      initialPartner = partnersList.find((option) => option.id.toString() === partnerCardId);
    }
  }

  const [customTouched, setCustomTouched] = useState({});
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [entity, setEntity] = useState(ENTITY[0].value);
  const [promocodesGenerator, setPromocodesGenerator] = useState(PROMOCODES_GENERATOR[0].value);
  const [updatesFieldsStatus, setUpdatesFieldsStatus] = useState({
    cities: false,
    cms: false
  });

  const updateFieldData = (fetch, name) => {
    dispatch(fetch({ update: true })).then((res) => {
      if (res.status === 200) {
        setUpdatesFieldsStatus(prevState => ({ ...prevState, [name]: true }));
      }
    });
  };

  const citiesForInitial = promotionCard?.cities?.map(city => ({ label: city?.name, value: city?.id })) || [];
  const initialCities = (citiesForInitial.length === cities?.slice(1)?.length || promotionCard?.all_cities) && citiesForInitial.length ? [{ label: 'Все', value: 'all' }, ...citiesForInitial] : citiesForInitial;

  const isActive = promotionCard.status === 'Активна' && isEdit;

  const initialValues = {
    date_start: isEdit || isCopy ? promotionCard.date_start : null,
    date_end: isEdit || isCopy ? promotionCard.date_end : null,
    cms_package_id: isEdit || isCopy ? promotionCard?.cms_package : null,
    discount: isEdit || isCopy ? promotionCard.discount : undefined,
    promo_code_amount: isCopy ? promotionCard.promo_code_amount || 1 : isEdit ? promotionCard.promo_code_amount : undefined,
    show_all: isCopy ? 'all' : isEdit ? !Object.values(promotionCard).length ? true : promotionCard.show_all : true,
    generate_promo_code: isCopy ? 'auto' : isEdit ? !Object.values(promotionCard).length ? true : promotionCard.generate_promo_code : true,
    is_enabled_promocodes: isEdit || isCopy ? promotionCard.is_enabled_promocodes : true, 
    customer_files: isCopy ? [] : isEdit ? customerFiles.items : [],
    promo_code_files: isCopy ? [] : isEdit ? promoFiles : [],
    partner_id: isEdit || isCopy ? promotionCard.partner : initialPartner,
    cities_id: isEdit || isCopy ? initialCities : [],
    site_url: isEdit || isCopy ? promotionCard.site_url : null,
  }

  const { handleSubmit, values, handleChange, handleBlur, setFieldValue, errors, dirty, isValid } = useFormik({
    initialValues,
    validationSchema: validationScheme(isActive, isActive ? promotionCard.promo_code_amount : 1),
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      const transformedValues = createPromotionFields(values, customTouched, addEventMode === ADD_EVENT_MODE.Edit)
      if (isEdit) {
        Object.keys(transformedValues).forEach(key => {
          if (transformedValues[key] === undefined) delete transformedValues[key];
        });
        if (transformedValues.customer_files)
          transformedValues.customer_files = transformedValues.customer_files
            .map(file => customerFiles.items.findIndex(item => item.id === file) > -1 ? null : file)
            .filter(file => file);
        if (Object.keys(transformedValues).length) dispatch(updatePromotion(id, transformedValues, () => history.push(ROUTES.PARTNERS)));
        else history.push(ROUTES.PARTNERS);
      } else dispatch(createPromotion(transformedValues)).then(res => {
        if (res?.status && res?.message) localStorage.setItem('promotionMessage', res.message);
        if (res?.status) history.push(ROUTES.PARTNERS);
      });
    }
  });

  useEffect(() => {
    isEdit && dispatch(getPromotionById(id));
    isCopy && dispatch(copyPromotion(id));
    !branches.length && dispatch(getCities());
    isAllowedToListPartners && dispatch(getPartnersList());
    !cms.length && dispatch(getCMS());
    (isEdit && !promotionCard.show_all) && dispatch(getCustomerFiles(id));
    (isEdit && !promotionCard.generate_promo_code) && dispatch(getPromoFiles(id));
  }, // eslint-disable-next-line
    [])

  const registerInput = (name) => ({
    name,
    value: values[name],
    error: (typeof values[name] === 'string' || typeof values[name] === 'number') && errors[name],

    ...mainStyleInput
  });

  const touchedById = (name) => isEdit && setCustomTouched({ [name]: true, ...customTouched });

  const headerTitle = isCopy ?
    'Копировать акцию' :
    isEdit ?
      'Редактировать акцию' :
      'Создать акцию';

  const navigateToAddPartner = () => history.push({
    pathname: ROUTES.PARTNERS_ADD_PARTNER,
    state: { from: location?.pathname },
  });

  const handlerUploadCustomerFiles = (file) => {
    let formData = new FormData();
    formData.append('file', file[0]);

    return dispatch(uploadCustomerFiles(formData, isEdit && promotionCard?.status === 'Создана' ? id : undefined));
  };

  const handlerDeleteCustomerFiles = (file_id) => {
    return dispatch(deleteCustomerFiles(id, file_id));
  };

  const handlerUploadPromoFiles = (file) => {
    let formData = new FormData();
    formData.append('file', file[0]);

    return dispatch(uploadPromoFiles(formData, isEdit && promotionCard?.status === 'Создана' ? id : undefined));
  };

  const handlerDeletePromoFiles = (file_id) => {
    return dispatch(deletePromoFiles(id, file_id));
  };

  if (
    (addEventMode === ADD_EVENT_MODE.Create && (!visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.createPartnerPromotions.value) || !isAllowedToListPartners)) ||
    (isEdit && !visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.updatePartnerPromotions.value)) ||
    (isCopy && !visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.copyPartnerPromotions.value))
  ) return null;

  return (
    ((promotionCard?.id?.toString() !== id || !Object.values(promotionCard).length || !cms.length || fetchingCard) && (isEdit || isCopy)) ?
      <Box><CircularProgressCenter data-testid="CircularProgressCenter"/></Box> :
      <Box id="add-event-partner">
        <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1" data-testid="Title">
          {headerTitle}
        </Typography>
        <Breadcrumbs>
          <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.PARTNERS}>
            Партнёры
          </Link>
          <Box>{headerTitle}</Box>
        </Breadcrumbs>

        <Paper sx={{ padding: '24px', marginTop: '24px' }}>
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '34px' }}>
              <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" columnGap="20px" mb="24px">
                  <Grid container gap="16px" sx={{ width: '448px' }}>
                    <CustomSelect
                      {...registerInput('partner_id')}
                      placeholder="Наименование партнёра"
                      onChange={() => {
                        touchedById('partner_id');
                        return handleChange;
                      }}
                      onBlur={handleBlur}
                      sx={{ width: '498px' }}
                      options={partnersList}
                      setFieldValue={setFieldValue}
                      disabled={fetchingCard || initialPartner}
                    />
                  </Grid>

                  <Tooltip title="Добавить партнера" placement="top">
                    <AddIcon
                      cursor="pointer"
                      onClick={navigateToAddPartner}
                      data-testid="AddPartner"
                    />
                  </Tooltip>
                </Box>

                <Box display="flex" alignItems="center" justifyContent="space-between" columnGap="20px" mb="24px">
                  <Grid container gap="16px" sx={{ width: '448px' }}>
                    <CustomSelect
                      {...registerInput('cms_package_id')}
                      placeholder="Название акции"
                      onChange={() => {
                        touchedById('cms_package_id');
                        return handleChange;
                      }}
                      onBlur={handleBlur}
                      sx={{ width: '498px' }}
                      options={cms}
                      setFieldValue={setFieldValue}
                      disabled={fetchingCard}
                    />
                  </Grid>
                  <Tooltip title="Обновить данные" placement="top">
                    <RestartAltIcon
                      sx={{
                        color: updatesFieldsStatus.cms ? 'success.main' : 'text.primary',
                        cursor: 'pointer'
                      }}
                      onClick={() => updateFieldData(getCMS, 'cms')}
                    />
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    minHeight: 120,
                    marginBottom: '20px',
                    padding: '12px',
                    border: '1px solid #dde1e5',
                    borderRadius: '12px'
                  }}>
                  <PromotionDescriptionContent
                    description={values?.cms_package_id?.description}
                    emptyText="Описание акции"
                  />
                </Box>
                <Box sx={{ width: '100%', marginBottom: '24px' }}>
                  <CustomInput
                    {...registerInput('discount')}
                    onChange={(e) => {
                      touchedById('discount');
                      return handleChange(e);
                    }}
                    style={{ width: '100%' }}
                    placeholder="Сумма предлагаемой скидки"
                    disabled={fetchingCard}
                  />
                </Box>
                <Box>
                  <Grid container flexWrap="nowrap" justifyContent="space-between" mb="24px">
                    <Box>
                      <CustomDateTimePicker
                        {...registerInput('date_start')}
                        setFieldValue={(name, val) => {
                          touchedById('date_start');
                          return setFieldValue(name, val);
                        }}
                        placeholder="Дата начала действия"
                        sx={{ width: '260px' }}
                        disabled={fetchingCard || isEdit}
                      />
                    </Box>
                    <Box>
                      <CustomDatePicker
                        {...registerInput('date_end')}
                        setFieldValue={(name, val) => {
                          touchedById('date_end');
                          return setFieldValue(name, val);
                        }}
                        placeholder="Дата окончания действия"
                        sx={{ width: '260px' }}
                        disabled={fetchingCard}
                        dateStart={values.date_start}
                      />
                    </Box>
                  </Grid>
                  <Box color="error.main" fontSize="1rem" textAlign="center">
                    {isActive ? errors?.date_end?.dateEndNotValid : (errors?.date_end?.dateEndNotValid || errors?.date_start?.dateStartNotValid)}
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="space-between" columnGap="20px" mb="24px">
                  <Grid container gap="16px" sx={{ width: '448px' }}>
                    <CustomMultiSelect
                      {...registerInput('cities_id')}
                      onChange={handleChange}
                      variant="outlined"
                      options={cities}
                      width={498}
                      placeholderColor="#667A8B"
                      setFieldValue={setFieldValue}
                      size="small"
                      placeholder="Города"
                      touchedBy={() => touchedById('cities_id')}
                      showAll={true}
                      disabled={fetchingCard}
                    />
                  </Grid>
                  <Tooltip title="Обновить данные" placement="top">
                    <RestartAltIcon
                      onClick={() => updateFieldData(getCities, 'cities')}
                      sx={{
                        color: updatesFieldsStatus.cities ? 'success.main' : 'text.primary',
                        cursor: 'pointer'
                      }}
                      data-testid="RestartAltIcon"
                    />
                  </Tooltip>
                </Box>
                <Grid item sx={{ width: '100%' }}>
                  <CustomInput
                    {...registerInput('site_url')}
                    placeholder="Web страница для получения услуги из МП"
                    onChange={(e) => {
                      touchedById('site_url');
                      return handleChange(e);
                    }}
                    onBlur={handleBlur}
                    sx={{ width: '100%', zIndex: '0' }}
                    disabled={fetchingCard}
                  />
                </Grid>
              </Box>
              <Box>
                <Grid item sx={{ width: '100%' }}>
                  <Typography variant="subtitleForm">Отображать для</Typography>
                  <CustomRadioGroup
                    disabled={fetchingCard}
                    name="show_all"
                    sx={{ mt: '12px' }}
                    options={ENTITY}
                    value={
                      typeof values?.show_all === 'boolean'
                        ? values?.show_all
                          ? ENTITY[0].value
                          : ENTITY[1].value
                        : entity
                    }
                    onChange={(e) => {
                      setEntity(e);
                      touchedById('show_all');
                    }}
                    setFieldValue={setFieldValue}
                  />
                  {(typeof values?.show_all === 'boolean'
                    ? !values?.show_all
                    : values?.show_all === ENTITY[1].value) && (
                    <UploadFiles
                      name="customer_files"
                      defaultFiles={values?.customer_files}
                      setFieldValue={(name, newFiles) => {
                        touchedById('customer_files');
                        return setFieldValue(name, newFiles);
                      }}
                      description="Форматы для загрузки: xls, xlsx."
                      validationUpload={validationFiles}
                      uploadFetch={handlerUploadCustomerFiles}
                      deleteFetch={promotionCard?.status === 'Создана' && addEventMode === ADD_EVENT_MODE.Edit ? handlerDeleteCustomerFiles : null}
                    />
                  )}
                </Grid>

                <Grid item sx={{ width: '100%', mt: '12px' }}>
                  <Typography variant="subtitleForm">Промокоды</Typography>
                  {isEdit && (
                    <>
                      <Typography mt="16px" color="text.secondary" sx={{ fontSize: '16px' }}>В акции уже действует { promotionCard.promo_code_amount } промокодов.</Typography>
                      <Typography color="text.secondary" sx={{ fontSize: '16px' }}>Для добавления дополнительных, выберите действие ниже</Typography>
                    </>
                  )}
                  <CustomRadioGroup
                    name="generate_promo_code"
                    sx={{ mb: '12px', mt: '12px' }}
                    options={PROMOCODES_GENERATOR}
                    value={
                      typeof values?.generate_promo_code === 'boolean'
                        ? values.is_enabled_promocodes
                          ? values?.generate_promo_code
                            ? PROMOCODES_GENERATOR[0].value
                            : PROMOCODES_GENERATOR[1].value
                          : PROMOCODES_GENERATOR[2].value
                        : promocodesGenerator
                    }
                    onChange={(e) => {
                      setPromocodesGenerator(e);
                      touchedById('generate_promo_code');
                    }}
                    setFieldValue={setFieldValue}
                    row={false}
                    disabled={fetchingCard || (isEdit && promocodesGenerator !== 'none')}
                  />
                  {(typeof values?.generate_promo_code === 'boolean'
                    ? values?.generate_promo_code
                    : values?.generate_promo_code === PROMOCODES_GENERATOR[0].value) && (
                    isEdit ?
                      <Box display="flex" gap="16px" lineHeight="36px">
                        Количество
                        <CustomCounter
                          {...registerInput('promo_code_amount')}
                          setFieldValue={setFieldValue}
                          disabled={fetchingCard}
                          touchedById={() => touchedById('promo_code_amount')}
                          isDecreaseDisabled={isActive}
                        />
                      </Box>
                      :
                      <CustomInput
                        {...registerInput('promo_code_amount')}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (!input || /^[1-9]$/.test(input[0]))
                            if (!input || /^[0-9]$/.test(input[input.length - 1])) {
                              touchedById('promo_code_amount');
                              return handleChange(e);
                            }
                        }}
                        style={{ width: '100%' }}
                        placeholder="Количество промокодов"
                        disabled={fetchingCard}
                      />
                  )}
                  {(typeof values?.generate_promo_code === 'boolean'
                    ? !values?.generate_promo_code
                    : values?.generate_promo_code === PROMOCODES_GENERATOR[1].value) && (
                    <UploadFiles
                      name="promo_code_files"
                      defaultFiles={values?.promo_code_files}
                      setFieldValue={(name, newFiles) => {
                        touchedById('promo_code_files');
                        return setFieldValue(name, newFiles);
                      }}
                      description="Форматы для загрузки: xls, xlsx."
                      validationUpload={validationFiles}
                      uploadFetch={handlerUploadPromoFiles}
                      deleteFetch={addEventMode === ADD_EVENT_MODE.Edit ? handlerDeletePromoFiles : null}
                    />
                  )}
                </Grid>

                <Box sx={{ mt: '32px' }}>
                  <Typography variant="subtitleForm">Баннер</Typography>
                  { !values.cms_package_id ?
                    <Typography mt="16px" color="text.secondary" sx={{ fontSize: '16px' }}>Нет данных. Укажите название акции</Typography> :
                    <Box sx={{ mt: '16px' }}>
                      <Box
                        component="img"
                        alt="Баннер пакета"
                        src={getAssetUrl(cms.find(item => item.id === values?.cms_package_id?.id)?.banner)}
                        sx={{
                          borderRadius: '8px',
                          width: '240px',
                          height: '240px'
                        }}
                      />
                    </Box>
                  }
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '24px'
              }}>
              <Typography color="error.main" width="500px">
                {error?.detail && (typeof error?.detail === 'string' ? error?.detail : JSON.stringify(error?.detail)) || (typeof error === 'string' && error)}
              </Typography>

              <Box>
                <CustomButton
                  size="large"
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    if (JSON.stringify(initialValues) === JSON.stringify(values)) history.push(ROUTES.PARTNERS);
                    else setIsCancelModal(true);
                  }}
                >
                  Отмена
                </CustomButton>

                <CustomButton
                  type="submit"
                  sx={{ marginLeft: '16px', width: '146px' }}
                  size="large"
                  variant="contained"
                  disabled={
                    isCopy && promotionCard.status === 'Создана' ? new Date(promotionCard.date_start) < new Date() :
                      isEdit ?
                        isActive ? JSON.stringify(initialValues) === JSON.stringify(values)
                          : !Object.values(customTouched).length || !isValid || !dirty
                        : !isValid || !dirty
                  }
                >
                  Сохранить
                </CustomButton>
              </Box>
            </Box>
          </form>

          <CustomModal
            opened={isCancelModal}
            modalClose={() => setIsCancelModal(false)}
            modalSubmit={() => history.push(ROUTES.PARTNERS)}
            text="Вы уверены, что хотите выйти, не сохранив данные?"
            cancelBtnName="Отмена"
            submitBtnName="Да"
          />
        </Paper>
      </Box>
  )
}
